module.exports = __webpack_public_path__ + "static/img/win11_3.06349a7.png";